export default "__VITE_ASSET__pR4kI5ct__"